import { getCustomSettings } from 'client/api/customSettings'
import { Toggle } from 'client/components/common/Toggle/Toggle'
import { TABS } from 'client/components/Modal/CompanyInformationModal/CompanyInformationModal'
import { ColoredAreasDropdown } from 'client/components/Modal/CompanyInformationModal/CustomSettingsModal/AreaSelector'
import { ColorSelection } from 'client/components/Modal/CompanyInformationModal/CustomSettingsModal/ColorSelection'
import { FontDropdown } from 'client/components/Modal/CompanyInformationModal/CustomSettingsModal/FontSelection'
// eslint-disable-next-line max-len
import { SelectInvoiceLines } from 'client/components/Modal/CompanyInformationModal/CustomSettingsModal/InvoiceLineSelector'
import { Spinner } from 'client/components/spinner/Spinner'
import { Color } from 'client/Global/Colors'
import { CustomSettingsInterface } from 'client/Interfaces/CustomSettingsInterface'
import { l } from 'client/Other/Translation'
import * as React from 'react'
import { useEffect, useState } from 'react'

const defaultCustomSettings: CustomSettingsInterface = {
  name: 'default',
  settings: {
    areas: ['total', 'header', 'columnHeaders', 'dividers'],
    font: 'openSans',
    invoiceHeaderLines: 'background',
    color: {
      text: `${Color.Black}`,
    },
  },
}

export const InvoiceTemplateForm = ({
  onChange,
  saveSettings,
  activeTab,
  canUseCustomSettings,
  openSubscriptionModal,
}) => {
  const formState = {
    customSettings: defaultCustomSettings,
    loaded: false,
    modified: false,
  }
  const [state, setState] = useState(formState)
  const [changedValues, setChangedValues] = useState([])

  useEffect(() => {
    if (activeTab === TABS.invoiceTemplate && state.loaded === false) {
      void getCustomSettings().then((res) => {
        if (!canUseCustomSettings) {
          setState({ ...state, loaded: true })
          saveSettings(defaultCustomSettings)
        } else {
          if (res.name) {
            setState({
              loaded: true,
              modified: false,
              customSettings: {
                name: res.name,
                settings: res.settings,
              },
            })
          } else {
            setState({ ...state, loaded: true })
            saveSettings(defaultCustomSettings)
          }
        }
      })
    }
  }, [state.loaded, activeTab])

  useEffect(() => {
    if (state.modified === true) {
      onChange(state.customSettings, Object.keys(changedValues))
    }
  }, [state.customSettings])

  return (
    <div className="companyInformationModal__form-wrapper InvoiceTemplateForm">
      {state.loaded ? (
        <div>
          <ColorSelection
            settings={state.customSettings}
            setSettings={setState}
            changedValues={changedValues}
            setChangedValues={setChangedValues}
          />
          <ColoredAreasDropdown
            settings={state.customSettings}
            setSettings={setState}
            changedValues={changedValues}
            setChangedValues={setChangedValues}
          />
          <FontDropdown
            settings={state.customSettings}
            setSettings={setState}
            changedValues={changedValues}
            setChangedValues={setChangedValues}
          />
          <SelectInvoiceLines
            settings={state.customSettings}
            setSettings={setState}
            changedValues={changedValues}
            setChangedValues={setChangedValues}
          />
          {!canUseCustomSettings ? (
            <div className="SelectInput Controlled CustomPremium">
              <span className="Label">
                <span>{l('customTemplates.enabled')}</span>
                <img src={'/images/premiumfeature/star_with_circle_green.svg'} />
              </span>
              <div className="PremiumToggle">
                <Toggle
                  value={false}
                  automation={'customSettingsEnable'}
                  onChange={() => openSubscriptionModal(state.customSettings)}
                />
                <p className="PremiumText">{l('customTemplates.additionalText')}</p>
              </div>
            </div>
          ) : null}
        </div>
      ) : (
        <div>
          <Spinner />
        </div>
      )}
    </div>
  )
}
